<h2 mat-dialog-title *ngIf="editfieldman.id === undefined"><i class="fas fa-plus me-2"></i>Create Fieldman</h2>
<h2 mat-dialog-title *ngIf="editfieldman.id !== undefined"><i class="fas fa-plus me-2"></i>Edit Fieldman for {{editfieldman.firstName}}</h2>
<mat-dialog-content class="mat-typography">
    <form #FieldmanForm="ngForm" id="FieldmanForm" name="FieldmanForm">
      <div class="row">
        <div class="form-group col-sm-6 mb-0">
          <mat-form-field class="d-block">
            <input matInput type="text" id="firstName" name="firstName" required [(ngModel)]="editfieldman.firstName"
              #firstName="ngModel" placeholder="First Name">
          </mat-form-field>
        </div>
        <div class="form-group col-sm-6 mb-0">
          <mat-form-field class="d-block">
            <input matInput type="text" id="lastName" name="lastName"  [(ngModel)]="editfieldman.lastName"
              #lastName="ngModel" placeholder="Last Name">
          </mat-form-field>
        </div>
        <div class="form-group col-sm-6 mb-0">
          <mat-form-field class="d-block">
            <input matInput type="text" id="email" name="email"  [(ngModel)]="editfieldman.email"
              #email="ngModel" placeholder="Email">
          </mat-form-field>
        </div>
        <div class="form-group col-sm-6 mb-0">
          <mat-form-field class="d-block">
            <input matInput type="text" id="phone" name="phone" [(ngModel)]="editfieldman.phone"
              #phone="ngModel" placeholder="Phone">
          </mat-form-field>
        </div>
      </div>
    </form>
</mat-dialog-content>
<mat-dialog-actions>
  <div class="custom-dialog-actions">
    <div class="btn-group">
      <button *ngIf="!submitting" type="submit" form="FieldmanForm" class="custom-button save-button"
        [disabled]="FieldmanForm.invalid" (click)="saveFieldmanClicked()">
        <span class="fa-icon-wrapper"><i class="fas fa-save"></i></span>Save
      </button>
      <mat-spinner *ngIf="submitting" [diameter]="20"></mat-spinner>
      <button class="custom-button cancel-button" (click)="cancelClicked(false)">
        <span class="fa-icon-wrapper"><i class="fas fa-times"></i></span>Cancel
      </button>
    </div>
   
  </div>
</mat-dialog-actions>

